import { render, staticRenderFns } from "./StockItemBranches.vue?vue&type=template&id=d7f97ee6&"
import script from "./StockItemBranches.vue?vue&type=script&lang=js&"
export * from "./StockItemBranches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports